<template>
  <div class="after_order_item" @click="goDetailFun(item)">
    <van-panel>
      <template #header>
        <div class="panel_header van-hairline--bottom">
          <p class="panel_header_title">
            <!-- <van-icon name="orders-o" size="17" /> -->
            <img src="@/assets/image/dan.png" class="dan_icon" alt="">
            售后单号:{{ item.returnCode }}
          </p>
          <!-- <p class="panel_header_desc">{{item.createTime}}</p> -->
          <p
            class="panel_header_value"
            :class="{ colorcc: item.status == 'FINISH' }"
          >
            {{ item.showStatus }}
          </p>
        </div>
      </template>
      <template #footer>
        <div class="footer" v-if="showFooterDowntime">
          <span class="footer_title2">
            【{{item.afterSaleTypeDisplayName}}】店铺已同意，您需要
            <van-count-down style="color: #f8a651;font-size: 12px;display: inline;" :time="time" format="DD天HH:mm:ss" />
            内处理<span style="color: #f8a651;">{{item.afterSaleTypeDisplayName}}</span>
          </span>
        </div>
        <div class="footer" v-else>
          <span class="footer_title">{{ item.nodeDescForUser }}</span>
        </div>
      </template>
      <div class="content">
        <div v-if="item.itemVO.length == 1">
          <div class="order_item" v-for="(t, idx) in item.itemVO" :key="idx">
            <div class="order_info">
              <div class="img">
                <van-image
                  :src="
                    t.imageInfo &&
                    t.imageInfo.imageUrl +
                      '?x-oss-process=style/style_myorder_list_img'
                  "
                  width="70"
                  height="70"
                  fit="cover"
                />
              </div>
              <div class="info">
                <p class="infop1">
                  <strong>{{ funSubstring(t.goodsName) }}</strong>
                </p>
                <p class="attr infop1">
                  {{ t.attributeValues }} <span>x{{ t.goodsCount }}</span>
                </p>
                <!-- <p class="attr" v-show="item.actualRefundPrice">退款:￥{{item.actualRefundPrice}}</p> -->
              </div>
            </div>
            <div class="refund_view" v-show="item.actualRefundPrice && item.afterSaleType !='CHANGE_PRODUCT'">
              <p>
                <span>{{item.afterSaleTypeDisplayNameOptimize}}总金额：</span
                ><span class="refund_money" v-price="item.actualRefundPrice"></span>
              </p>
            </div>
            <div class="refund_view" v-show="item.afterSaleType === 'CHANGE_PRODUCT'">
              <p>
                <span>换货数量：</span><span class="refund_money" > X{{item.count}}</span>
              </p>
            </div>

            <div v-show="item.branchPassTimeMills">
              <van-count-down
                style="color: #ee0a24"
                :time="time"
                format="DD 天 HH 时 mm 分 ss 秒"
              />
            </div>
          </div>
        </div>
        <div class="order_item" v-if="item.itemVO.length > 1">
          <div class="order_info_img" style="position: relative">
            <van-image
              :src="
                t.skuImageKey &&
                t.skuImageKey + '?x-oss-process=style/style_myorder_list_img'
              "
              width="70"
              height="70"
              fit="cover"
              v-for="(t, idx) in item.itemVO"
              :key="idx"
            />
            <!-- 数量 -->
            <div class="num_view">
              <div class="num_cont">共{{ item.itemVO.length }}件</div>
            </div>
          </div>

          <div v-show="item.branchPassTimeMills">
            <van-count-down
              style="color: #ee0a24"
              :time="time"
              format="DD 天 HH 时 mm 分 ss 秒"
            />
          </div>
          <!-- <div class="order_info_desc">共{{item.itemVO.length}}件商品，共计<strong>￥{{item.actualRefundPrice}}</strong></div> -->

          <div class="refund_view" v-show="item.actualRefundPrice && item.afterSaleType !='CHANGE_PRODUCT'">
            <p>
              <span>{{item.afterSaleTypeDisplayNameOptimize}}总金额：</span
              ><span class="refund_money">￥{{ item.actualRefundPrice }}</span>
            </p>
          </div>
          <div class="refund_view" v-if="item.afterSaleType === 'CHANGE_PRODUCT'">
            <p>
              <span>换货数量：</span><span class="refund_money" > X{{item.count}}</span>
            </p>
          </div>
        
          
        </div>
      </div>
    </van-panel>
    <!-- <div v-show="item.adjustOrderAfterList && item.adjustOrderAfterList.length > 0" >
      <van-panel
        class="bucss"
        v-for="tt in item.adjustOrderAfterList"
        :key="tt.id"
      >
        <template #header>
          <div class="panel_header van-hairline--bottom">
            <p class="panel_header_title">补/退差价</p>
          </div>
        </template>
        <div class="content">
          <div class="order_item">
            <div class="order_info">
              <div class="img">
                <van-image
                  :src="
                    tt.skuImageUrl +
                    '?x-oss-process=style/style_myorder_list_img'
                  "
                  width="70"
                  height="70"
                  fit="cover"
                />
              </div>
              <div class="info">
                <p class="infop1">
                  <strong>{{ funSubstring(tt.itemName) }}</strong>
                </p>
              </div>
              <p class="text">
                补款总额: <span class="red">￥{{ tt.adjustSumPrice }}</span>
              </p>
            </div>
          </div>
        </div>
      </van-panel>
    </div> -->
  </div>
</template>
<script>
// import strollBrandVue from "../../brand/strollBrand.vue";
import utils from '@/utils/common';

export default {
  data() {
    return {
      time: 0
    };
  },
  props: {
    item: {
      default: function () {
        return {};
      },
      type: Object,
    },
  },
  methods: {
    funStatus(status) {
      let text = "";
      switch (status) {
        case "SALE_AFTER_REJECT":
          text = "售后失败";
          break;
        case "WAIT_CHECK":
          text = "待审核";
          break;
        case "RETURN_GOODS_ING":
          text = "换货处理中";
          break;
        case "RETURN_MONEY_ING":
          text = "退货处理中";
          break;
        case "FINISH":
          text = "售后完成";
          break;
        case "ALREADY_CANCEL":
          text = "已取消";
          break;
        default:
          break;
      }
      return text;
    },
    contactFun(bid) {
      Util.contactBees(bid);
    },
    funSubstring(name) {
      if (name && name.length > 20) {
        return `${name.substring(20, 0)}...`;
      } else {
        return name;
      }
    },
    goDetailFun(item) {
      if (item.IS_GOODS) {
        this.$router.push({
          name: "userAfterOrderDetail",
          query: {
            afterId: item.id,
          },
        });
      } else {
        utils.jumpToNewPage({
          url: `${location.origin}/h5user/couponRefundDetail?id=${item.id}`,
          noTitle: '0'
        });
      }
    },
  },
  created() {
    let nowTime = new Date().getTime();
    let targetTime = this.item.branchPassTimeMills || 0;
    if (targetTime) {
      let spanTime1 = nowTime - targetTime;
      let spanTime = 1000 * 60 * 60 * 24 * 7 - spanTime1;
      this.time = spanTime;
    }
  },
  computed:{
    showFooterDowntime(){
      if((this.item.afterSaleType == 'JUST_PRODUCT'
      && this.item.status ==  'USER_SEND_GOODS_ING'
      && this.item.branchPassTimeMills != null)

      || (this.item.afterSaleType == 'CHANGE_PRODUCT'
      && this.item.status ==  'USER_SEND_GOODS_ING'
      && this.item.branchPassTimeMills != null)){
        return true
      }else{
        return false
      }
    }
  }
}
</script>
<style lang="less" scoped>
.dan_icon{
  width: 40px;
}
.num_view {
  width: 120px;
  height: 140px;
  position: absolute;
  right: 0;
  top: 0;
  text-align: center;
  background-color: #fff;
  font-size: 24px;
  color: #999;
  z-index: 1000;
}
.num_cont {
  line-height: 140px;
  width: 80%;
  height: 100%;
  background-color: #f7f7f7;
  margin-left: 10%;
  float: right;
}
.refund_view {
  font-size: 24px;
  padding-top: 20px;
  text-align: right;
  .refund_money {
    font-weight: bold;
    color: #ED3939;
    font-family: DINAlternate-Bold, DINAlternate;
  }
}
.refund_view span:first-child {
  color: #999999;
}
// refund_view span{color: #ED3939;}

.after_order_item {
  margin: 10px 20px;
  .red {
    color: red !important;
  }
  .van-cell-group {
    border-radius: 10px;
  }
  .van-hairline--top::after {
    border-top-width: 0;
  }
  .panel_header {
    .van-icon {
      color: #999;
      padding-right: 10px;
    }
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    padding: 20px 30px;
    .panel_header_title {
      color: #333333;
      font-size: 24px;
      display: flex;
      align-items: center;
      font-weight: 500;
      // background: #F8D541;
    }
    .panel_header_value {
      color: #f8a651;
      font-size: 26px;
    }
    .panel_header_desc {
      color: #ccc;
      font-size: 20px;
    }
    .colorcc {
      color: #ccc;
    }
  }
  .footer {
    font-size: 20px;
    color: #999;
    // height: 80px;
    line-height: 40px;
    background: #f7f7f7;
    border-radius: 10px;
    padding: 12px 10px;
    .footer_title {
      color: #999;
      padding: 0 20px;
      font-weight: 500;
      overflow:hidden; 
      text-overflow:ellipsis;
      display:-webkit-box; 
      -webkit-box-orient:vertical;
      -webkit-line-clamp:2; 
    }
    .footer_title2 {
      color: #999;
      padding: 0 20px;
      font-weight: 500;
      overflow:hidden; 
      // text-overflow:ellipsis;
      display:-webkit-box; 
      // -webkit-box-orient:vertical;
      // -webkit-line-clamp:2;
      display: inline;
    }
  }
  .order_item {
    padding: 10px 30px;
    .order_info {
      display: flex;
      .info {
        flex: 1;
        .infop1 {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 26px;
          span {
            color: #999;
          }
          strong {
            color: #333;
          }
        }
        .attr {
          color: #999999;
          font-size: 24px;
          padding: 72px 0 0 0;
        }
      }

      .img {
        width: 140px;
        height: 140px;
        padding-right: 20px;
      }
    }
    .order_info_img {
      white-space: nowrap;
      flex-wrap: nowrap;
      overflow-x: scroll;
      overflow-y: hidden;
      .van-image {
        padding-right: 15px;
      }
    }
    .order_info_desc {
      font-size: 26px;
      text-align: right;
      color: #999;
      strong {
        color: #333;
      }
    }
  }
  .bucss {
    margin-top: -10px;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    [class*="van-hairline"]::after {
      position: absolute;
      box-sizing: border-box;
      content: " ";
      pointer-events: none;
      top: -50%;
      right: -50%;
      bottom: -50%;
      left: -50%;
      border: 0px;
    }
    .text {
      padding-top: 100px;
      color: #999999;
      font-size: 26px;
    }
    .red {
      color: #ed3939;
    }
  }
}
</style>